<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzyCodeSearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="disEnable" size="mini" type="danger" @click="enableOrNot(false)">{{ $t('CargoMsg.Cargo_Invalid2') }}</el-button>
        <el-button no="enable" type="primary" @click="enableOrNot(true)">{{ $t('CargoMsg.Cargo_Enable') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="flex-grow: 1;">
      <cargo-ag-grid
        no="grid"
        config-module="101373"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="101373"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="380px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required :label="$t('CargoMsg.Cargo_Code')">
            <el-input v-model="editDialog.form.productCode" no="productCode" />
          </el-form-item>
          <el-form-item required :label="$t('CargoMsg.Cargo_ChineseNamed')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item required :label="$t('CargoMsg.Cargo_EnglishNamed')">
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-checkbox v-model="editDialog.form.seaExportEnabled" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForSeaExportBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.seaImportEnabled" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForSeaImportBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.airExportEnabled" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForAirExportBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.airImportEnabled" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForAirImportBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.railwayFreight" class="custom-checkbox">{{ $t('CargoMsg.RailwayUse') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.intergraed" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForIntegratedJob') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.fbaSea" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForFbaSeaBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.fbaAir" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForFbaAirBusiness') }}</el-checkbox>
          <el-checkbox v-model="editDialog.form.fbaRailway" class="custom-checkbox">{{ $t('CargoMsg.Cargo_ForFbaRailwayBusiness') }}</el-checkbox>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllowSaleProductList,
  saveAllowSaleProduct,
  enableOrNot
} from '@/api/sysManage/baseConfig/AllowSaleProduct'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import {
  syncSpecificBasicData,
  updateSpecificBasicData
} from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getGridSelected } from '@/utils/agGrid'

export default {
  name: 'AllowSaleProduct',
  components: { cargoAdvanceSelect },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        },
        onRowClicked: event => {
          this.onRowClicked(event)
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'productCode',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'chineseName',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Enable'),
          field: 'statusEnabled',
          initialWidth: 150,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForSeaExportBusiness'),
          field: 'seaExportEnabled',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForSeaImportBusiness'),
          field: 'seaImportEnabled',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForAirExportBusiness'),
          field: 'airExportEnabled',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForAirImportBusiness'),
          field: 'airImportEnabled',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.RailwayUse'),
          field: 'railwayFreight',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForIntegratedJob'),
          field: 'intergraed',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForFbaSeaBusiness'),
          field: 'fbaSea',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForFbaAirBusiness'),
          field: 'fbaAir',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForFbaRailwayBusiness'),
          field: 'fbaRailway',
          initialWidth: 200,
          cellStyle: { textAlign: 'center' },
          cellRenderer: (params) => {
            return ColumnUtils.booleanColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          productCode: '',
          chineseName: '',
          englishName: '',
          statusEnabled: '',
          seaExportEnabled: '',
          seaImportEnabled: '',
          airExportEnabled: '',
          airImportEnabled: '',
          railwayFreight: '',
          intergraed: '',
          fbaSea: '',
          fbaAir: '',
          fbaRailway: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const loading = getLoading()
      this.filter.likeName = this.filter.likeName.trim()
      getAllowSaleProductList(this.filter).then(res => {
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          productCode: '',
          chineseName: '',
          englishName: '',
          statusEnabled: '',
          seaExportEnabled: '',
          seaImportEnabled: '',
          airExportEnabled: '',
          airImportEnabled: '',
          railwayFreight: '',
          intergraed: '',
          fbaSea: '',
          fbaAir: '',
          fbaRailway: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length !== 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.productCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.chineseName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChineseNameCanTBeEmpty'))
        return
      }
      if (!form.englishName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameCanTBeEmpty'))
        return
      }
      this.loading = getLoading()
      saveAllowSaleProduct(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.editDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 启用或禁用可售卖产品
    enableOrNot(statusEnabled = true) {
      const selectedRows = getGridSelected(this.gridOptions)
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      const keys = []
      for (const item of selectedRows) {
        if (statusEnabled) { // 启用
          if (!item.statusEnabled) {
            keys.push(item.uuid)
          }
        } else { // 禁用
          if (item.statusEnabled) {
            keys.push(item.uuid)
          }
        }
      }
      if (keys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataCanBeModified'))
        return
      }
      this.loading = getLoading()
      enableOrNot({ 'keys': keys, 'statusEnabled': statusEnabled }).then(() => {
        if (statusEnabled) {
          this.$message.success(this.$t('CargoMsg.Cargo_DataEnableSuccess'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_DataDisEnableSuccess'))
        }
        this.toQuery()
        updateSpecificBasicData(basicCacheKeys.basic_data_AllowSaleProduct)
        syncSpecificBasicData(basicCacheKeys.basic_data_AllowSaleProduct)
      }).catch(() => {
        this.loading.close()
      })
    },
    async cancel() {
      this.editDialog.visible = false
    }
  }
}
</script>

<style scoped>
.custom-checkbox {
  padding-left: 2px;
  display: block;
}
</style>
